import { createPortal } from 'react-dom'

const mountIfExists = (id, render) => {
  const mountPoint = document.getElementById(id)
  return mountPoint && createPortal(render(), mountPoint)
}

export default mountIfExists
